<h2 class="h4 mt-0 mb-1">Sign up</h2>
<p [tcColor]="'#8f8f90'">Create your Account</p>

<register-form></register-form>

<!-- <p class="mt-5">Have an account? <a [routerLink]="['../', 'sign-in']">Sign in!</a></p> -->
